import { render, staticRenderFns } from "./program-social-management-and-inclusion.vue?vue&type=template&id=30ee8dc8"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports